import config from "@/static/config";
const user = {
  login: {
    name: " 账号登录",
    type: "post",
    path: config.account + "/login",
    proxy: "proxy", // 2026-10-18 本地开发直连：dev 走 devServer /rbac→18081（prod 的 account 为绝对域名，不受影响）
  },
  logout: {
    name: " 账号退出",
    type: "post",
    path: config.account + "/user/logout",
    proxy: "proxy", // 同上
  },
  accountCheck: {
    name: "验证账号和手机号是否可用",
    type: "get",
    path: config.account + "/user/account/check",
    proxy: "proxy", // 2026-10-18 本地直连（同 login）
  },
  userInfo: {
    name: "获取登录用户信息",
    type: "get",
    path: config.account + "/user/info",
    proxy: "proxy", // 2026-10-18 本地直连（同 login）——修复 /manager/rbac/user/info 双拼 404
  },
  checkVerification: {
    name: "验证修改密码手机号和验证码是否匹配",
    type: "get",
    path: config.account + "/user/check/s/verification",
    proxy: "proxy", // 2026-10-18 本地直连（同 login）
  },
  sseRegister: {
    name: "建立长连接",
    type: "get",
    path: config.sseUrl + "/sse/register",
  },
  accountPermission: {
    name: "获取登录用户的权限树",
    type: "get",
    path: config.baseUrl + "permission/account",
    proxy: "proxy", // 2026-10-18 本地直连：/managerpermission/* 由 devServer 重写为 /manager/permission/*
  },
  accountPermissionTree: {
    name: "获取登录用户的权限树",
    type: "get",
    path: config.baseUrl + "permission/account/floor",
    proxy: "proxy", // 2026-10-18 同上
  },
  uploadFile: {
    name: "上传图片",
    type: "post",
    path: config.resUrl + "api/file/upload",
  },
};
export default user;
